import FormFieldModel from '../../../../common/types/models/form-field-model'
import {STANDARD_ITEM_RULES} from '../../../../common/constants'

export const REGION: FormFieldModel = {
    name: 'region',
    label: 'Регион',
    tooltip: 'Укажите регион собственника транспортного средства',
    rules: STANDARD_ITEM_RULES,
}

export const LOCATION: FormFieldModel = {
    name: 'location',
    label: 'Территория / улица',
    tooltip: 'Укажите населенный пункт или улицу собственника транспортного средства',
    rules: STANDARD_ITEM_RULES,
}

export const POWER: FormFieldModel = {
    name: 'enginePower',
    label: 'Мощность',
    tooltip: 'Укажите мощность транспортного средства в лошадиных силах',
    rules: STANDARD_ITEM_RULES,
}

export const DRIVING_EXPERIENCE: FormFieldModel = {
    name: 'drivingExperience',
    label: 'Возраст и стаж',
    rules: STANDARD_ITEM_RULES,
    tooltip: 'Укажите возраст и стаж допущенного к управлению',
}

export const KBM: FormFieldModel = {
    name: 'kbm',
    label: 'КБМ',
    rules: [
        ...STANDARD_ITEM_RULES,
        () => ({
            validator(_, value) {
                if (value >= 0.46 && value <= 3.92) {
                    return Promise.resolve()
                }
                return Promise.reject(new Error('КБМ должен быть в диапазоне от 0,46 до 3,92'))
            },
        }),
    ],
}

export const VEHICLE_TYPE: FormFieldModel = {
    name: 'vehicleType',
    label: 'Тип ТС',
    rules: STANDARD_ITEM_RULES,
}

export const UNLIMITED_DRIVERS_LIST: FormFieldModel = {
    name: 'unlimitedDriversList',
    label: 'Неограниченное количество ЛДУ',
    valuePropName: 'checked',
}

export const TRAILER: FormFieldModel = {
    name: 'trailer',
    label: 'Прицеп',
    valuePropName: 'checked',
}

export const OWNER_IS_LEGAL_ENTITY: FormFieldModel = {
    name: 'legalPerson',
    label: 'Собственник ТС',
}

/** @deprecated */
export const REGISTERED_ABROAD: FormFieldModel = {
    name: 'registeredAbroad',
    label: 'Регистрация ТС',
}

export const PERIOD: FormFieldModel = {
    name: 'insurancePeriod',
    label: 'Срок страхования',
    rules: STANDARD_ITEM_RULES,
}

export const DATE_END: FormFieldModel = {
    name: 'dateEnd',
    label: 'Дата окончания договора',
    rules: STANDARD_ITEM_RULES,
}

export const PERIOD_SEASONAL: FormFieldModel = {
    name: 'usingPeriod',
    label: 'Период сезонного использования',
    rules: STANDARD_ITEM_RULES,
}

export const CALC_DATE: FormFieldModel = {
    name: 'calcDate',
    label: 'Дата расчета',
    rules: STANDARD_ITEM_RULES,
}

export const VEHICLE_REGISTRATION_COUNTRY: FormFieldModel = {
    name: 'vehicleRegistrationCountry',
    label: 'Страна регистрации ТС',
    rules: STANDARD_ITEM_RULES,
}

export const OWNER_REGISTRATION_COUNTRY: FormFieldModel = {
    name: 'ownerRegistrationCountry',
    label: 'Страна регистрации собственника',
    rules: STANDARD_ITEM_RULES,
}

export default {
    REGION,
    LOCATION,
    POWER,
    DRIVING_EXPERIENCE,
    KBM,
    VEHICLE_TYPE,
    UNLIMITED_DRIVERS_LIST,
    TRAILER,
    OWNER_IS_LEGAL_ENTITY,
    REGISTERED_ABROAD,
    PERIOD,
    PERIOD_SEASONAL,
    CALC_DATE,
    VEHICLE_REGISTRATION_COUNTRY,
    OWNER_REGISTRATION_COUNTRY,
}
